import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import redemptionsSelectors from 'models/Redemptions/selectors'

import ScreenContainer from 'components/ScreenContainer'

import { STRING } from 'resources'

import { Container, Title, TitleButtonSection, TitleAccent, Content } from './styles'

import RedemptionRequirements from './RedemptionRequirements'
import RedemptionRequirementsBanner from './RedemptionRequirementsBanner'

const WalletScreenHeader = ({ promptUserRefresh }) => {
  const isFetchingRedemptionOptionsStatus = useSelector(redemptionsSelectors.getIsFetchingRedemptionOptionsStatus)
  const isRequirementMissing = useSelector(redemptionsSelectors.getIsRequirementMissing)

  const [isRedemptionRequirementsModalOpen, setIsRedemptionRequirementsModalOpen] = useState(false)

  return (
    <Container>
      {!isFetchingRedemptionOptionsStatus && isRequirementMissing && (
        <RedemptionRequirementsBanner handleOpenModal={() => setIsRedemptionRequirementsModalOpen(true)} />
      )}
      <RedemptionRequirements
        isOpen={isRedemptionRequirementsModalOpen}
        onClose={() => setIsRedemptionRequirementsModalOpen(false)}
        promptUserRefresh={promptUserRefresh}
      />
      <Content>
        <ScreenContainer>
          <TitleButtonSection>
            <Title>
              {STRING.wallet.pageTitle.part1}
              <TitleAccent>{STRING.wallet.pageTitle.part2}</TitleAccent>
            </Title>
          </TitleButtonSection>
        </ScreenContainer>
      </Content>
    </Container>
  )
}

WalletScreenHeader.propTypes = {
  promptUserRefresh: PropTypes.bool.isRequired,
}

export default WalletScreenHeader
